import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { PhieuNhapDieuChuyenChiTiet } from '@/types/schemas';

type DetailCellParams = DataTableRenderCellParams<PhieuNhapDieuChuyenChiTiet>;

export const getDetailTableColumns = (): DataTableColumn<PhieuNhapDieuChuyenChiTiet>[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã vật tư',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_vt_data?.ma_vt}</div>;
    }
  },
  {
    field: 'ten_vt',
    headerName: 'Tên vật tư',
    width: 200,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_vt_data?.ten_vt}</div>;
    }
  },
  {
    field: 'dvt',
    headerName: 'Đvt',
    width: 80,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.dvt_data?.dvt}</div>;
    }
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho nhập',
    width: 100,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_kho_data?.ma_kho}</div>;
    }
  },
  {
    field: 'ma_vi_tri',
    headerName: 'Đến vị trí',
    width: 100,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_vi_tri_data?.ma_vi_tri}</div>;
    }
  },
  {
    field: 'ma_vi_trin',
    headerName: 'Từ vị trí',
    width: 100,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_vi_trin_data?.ma_vi_trin}</div>;
    }
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    type: 'number',
    width: 100
  },
  { field: 'pn_tb', headerName: 'Giá trung bình', type: 'boolean', width: 100 },
  { field: 'gia_nt', headerName: 'Giá VND', type: 'number', width: 100 },
  { field: 'tien_nt', headerName: 'Tiền VND', type: 'number', width: 100 },
  {
    field: 'tk_du',
    headerName: 'TK nợ',
    width: 100,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.tk_du_data?.code}</div>;
    }
  },
  {
    field: 'ma_nx',
    headerName: 'Lý do nhập',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_nx_data?.ma_nx}</div>;
    }
  },
  {
    field: 'tk_vt',
    headerName: 'TK có',
    width: 100,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.tk_vt_data?.code}</div>;
    }
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_bp_data?.ma_bp}</div>;
    }
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_vv_data?.ma_vv}</div>;
    }
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_hd_data?.ma_hd}</div>;
    }
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_dtt_data?.ma_dtt}</div>;
    }
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_ku_data?.ma_ku}</div>;
    }
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_phi_data?.ma_phi}</div>;
    }
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell(params: DetailCellParams) {
      return <div>{params?.row?.ma_sp_data?.ma_sp}</div>;
    }
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 120,
    renderCell(params) {
      return <div>{params?.row?.ma_lsx_data?.ma_lsx}</div>;
    }
  },
  { field: 'so_ct_px', headerName: 'Số PX đ/c', width: 200 }
];
